import React from 'react';
import { Item, Section } from 'react-stately';

import { BaseItem, Section as BaseSection } from '../Item/types';
import { ItemContent } from '../ItemContent/ItemContent';
import { isSection } from '../Item/utils';

export function getDefaultRenderer<
    TSingleItem extends BaseItem,
    TSection extends BaseItem & BaseSection<string, TSingleItem>,
>(getItemKey: (i: TSingleItem | TSection) => string) {
    const entryRenderer = (item: TSingleItem | TSection) => {
        const key = getItemKey(item);

        if (isSection(item)) {
            return (
                <Section key={item.key} items={item.options} title={item.title}>
                    {entryRenderer}
                </Section>
            );
        }

        const textValue = item.label ?? (typeof item.content === 'string' ? item.content : key);

        return (
            <Item
                key={key}
                textValue={textValue}
                href={item.url}
                target={item.target}
                routerOptions={item.routerOptions}
            >
                <ItemContent item={item} />
            </Item>
        );
    };

    return entryRenderer;
}
